/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendProductDto } from '../../models/backend-product-dto';

export interface OpexesProductsCopyCreate$Params {
  id: number;
}

export function opexesProductsCopyCreate(
  http: HttpClient,
  rootUrl: string,
  params: OpexesProductsCopyCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendProductDto>> {
  const rb = new RequestBuilder(rootUrl, opexesProductsCopyCreate.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendProductDto>;
    }),
  );
}

opexesProductsCopyCreate.PATH = '/api/opexes/products/{id}/copy/';
